/*---------------------------------------*\
   Import classes
\*---------------------------------------*/

//Components
import {Accordion} from "./classes/Accordion";
import {Animation} from "./classes/Animation";
import {FloatLabel} from "./classes/FloatLabel";
import {Fullpage} from "./classes/Fullpage";
import {Gallery} from "./classes/Gallery";
import {Parallax} from "./classes/Parallax";
// import ScrollTo from "./classes/ScrollTo";
import * as noUiSlider from "../../../node_modules/nouislider/dist/nouislider";
import ImageRatio from "./classes/ImageRatio";
import {Datepicker} from "./classes/Datepicker";
import {JqueryValidator} from "./classes/JqueryValidator";
import {Darujme} from "./classes/Darujme";
import {VterinaCounter} from "./classes/VterinaCounter";
import {SignToDonate} from "./classes/SignToDonate";
import {CloudflareTurnstille} from "./classes/CloudflareTurnstille";
import {FormValidation} from "./classes/FormValidation";
import {GA} from "./classes/GA";

var $ = jQuery;

$(document).ready(function() {

    // Detekce kliknutí na odkazy s kotvou
    $('a[href^="#"]').on('click', function(event) {
        // NOVÁ PODMÍNKA: Pokud má odkaz atribut 'data-fancybox', nic nedělej a nech to na Fancyboxu.
        if ($(this).is('[data-fancybox]')) {
            // Pokud ano, je to odkaz pro modal. Nic neděláme a necháme práci na Fancyboxu.
            return;
        }
        
        // Kontrola, zda je kotva validní
        var target = $(this.getAttribute('href'));
        if (target.length) {
            event.preventDefault(); // Zamezení defaultní akci (skok na kotvu)

            // Plynulý scroll na kotvu
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 1000); // Rychlost scrollování (800ms)
        }
    });

    // Plynulé scrollování na kotvu při načtení stránky, pokud je kotva v URL
    if (window.location.hash) {
        // Uložíme kotvu a dočasně ji odstraníme
        var hash = window.location.hash;
        window.location.hash = ''; // Dočasně odstraníme kotvu z URL

        // Po načtení stránky plynule přejdeme na kotvu
        var target = $(hash);
        if (target.length) {
        $('html, body').animate({
            scrollTop: target.offset().top
        }, 1000, function() {
            // Po dokončení animace vrátíme kotvu zpět do URL
            window.location.hash = hash;
        });
        }
    }

});

/*---------------------------------------*\
   Functions
\*---------------------------------------*/

function getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
}

/**
 * CTA button show, hide
 *
 * @returns {boolean}
 */
function hideSignBtnAtScroll() {
    var $footer = $('.website-footer-inner');

    if ($(window).width() > 767) {
        $footer.removeClass('is-floating-button');
        //
        return false;
    }

    var $btn = $('.js-btn-form .btn');
    var $form = $($btn.attr('href'));

    $footer.addClass('is-floating-button');

    // unbind
    $btn.unbind('mouseenter mouseleave');

    // Check if form exists
    if ($form.length == 0) {
        return;
    }


    var elementTop = $form.offset().top;
    var elementBottom = elementTop + $form.outerHeight();
    //
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    if (elementBottom > viewportTop && elementTop < viewportBottom) {
        $btn.parent().addClass("opacity");
    } else {
        $btn.parent().removeClass("opacity");
    }
}

function storyAnimation() {
    let container = $('.JS-story-animation-container');
    let smoke = container.find('.JS-story-smoke');
    let smokeBg = container.find('.JS-smoke-bg');

    setTimeout(function () {
        smoke.addClass('smoke-show');
        smokeBg.show();
        playStoryVideo();
    }, 5000);

    setTimeout(function () {
        container.find('#story-first').fadeOut(500);
        container.find('#story-first').find('.JS-story-info').fadeOut(500);
        container.find('#story-second').fadeIn(1000);
    }, 6000);

    setTimeout(function () {
        smoke.fadeOut(1000);
    }, 6500);

    setTimeout(function () {
        smoke.removeClass('smoke-show');
        smoke.removeAttr('style');
        smokeBg.hide();
    }, 8000);

    setTimeout(function () {
        container.find('#story-second').find('.JS-story-text').fadeIn(1000);
    }, 9000);

    setTimeout(function () {
        container.find('#story-second').find('.JS-story-bg-1').fadeOut(1500);
        container.find('#story-second').find('.JS-story-bg-2').fadeIn(1500);
    }, 10000);

    setTimeout(function () {
        smoke.addClass('smoke-show');
        smokeBg.show();
        playStoryVideo();
    }, 14000);

    setTimeout(function () {
        container.find('#story-second').fadeOut(500);
        container.find('#story-second').find('.JS-story-info').fadeOut(500);
        container.find('#story-third').fadeIn(1000);
    }, 15000);

    setTimeout(function () {
        smoke.fadeOut(1000);
    }, 15500);

    setTimeout(function () {
        smoke.removeClass('smoke-show');
        smoke.removeAttr('style');
        smokeBg.hide();
    }, 17000);

    setTimeout(function () {
        container.find('#story-third').find('.JS-story-text').fadeIn(1000);
    }, 18000);

    setTimeout(function () {
        container.find('#story-third').find('.JS-story-bg-1').fadeOut(1500);
        container.find('#story-third').find('.JS-story-bg-2').fadeIn(1500);
    }, 19000);

    setTimeout(function () {
        smoke.addClass('smoke-show');
        smokeBg.show();
        playStoryVideo();
    }, 23000);

    setTimeout(function () {
        container.find('#story-third').fadeOut(500);
        container.find('#story-third').find('.JS-story-info').fadeOut(500);
        container.find('#story-fourth').fadeIn(1000);
    }, 24000);

    setTimeout(function () {
        smoke.fadeOut(1000);
    }, 24500);

    setTimeout(function () {
        smoke.removeClass('smoke-show');
        smoke.removeAttr('style');
        smokeBg.hide();
    }, 26000);

    setTimeout(function () {
        container.find('#story-fourth').find('.JS-story-text').fadeIn(1000);
    }, 27000);

    setTimeout(function () {
        container.find('#story-fourth').find('.JS-story-bg-1').fadeOut(1500);
        container.find('#story-fourth').find('.JS-story-bg-2').fadeIn(1500);
    }, 28000);

    setTimeout(function () {
        smoke.addClass('smoke-show');
        smokeBg.show();
        playStoryVideo();
    }, 32000);

    setTimeout(function () {
        container.find('#story-fourth').fadeOut(500);
        container.find('#story-fourth').find('.JS-story-info').fadeOut(500);
        container.find('#story-fifth').fadeIn(1000);
    }, 33000);

    setTimeout(function () {
        smoke.fadeOut(1000);
    }, 33500);

    setTimeout(function () {
        smoke.removeClass('smoke-show');
        smoke.removeAttr('style');
        smokeBg.hide();
    }, 35000);

    setTimeout(function () {
        container.find('#story-fifth').find('.JS-story-text').fadeIn(1000);
    }, 36000);

    setTimeout(function () {
        container.find('#story-fifth').find('.JS-story-bg-1').fadeOut(1500);
        container.find('#story-fifth').find('.JS-story-bg-2').fadeIn(1500);
    }, 37000);

    setTimeout(function () {
        smoke.addClass('smoke-show');
        smokeBg.show();
        playStoryVideo();
    }, 41000);

    setTimeout(function () {
        container.find('#story-fifth').fadeOut(500);
        container.find('#story-fifth').find('.JS-story-info').fadeOut(500);
        container.find('#story-sixth').fadeIn(1000);
    }, 42000);

    setTimeout(function () {
        smoke.fadeOut(1000);
    }, 42500);

    setTimeout(function () {
        smoke.removeClass('smoke-show');
        smoke.removeAttr('style');
        smokeBg.hide();
    }, 44000);

    setTimeout(function () {
        container.find('#story-sixth').find('.JS-story-text').fadeIn(1000);
    }, 45000);

    setTimeout(function () {
        container.find('#story-sixth').find('.JS-story-bg-1').fadeOut(1500);
        container.find('#story-sixth').find('.JS-story-bg-2').fadeIn(1500);
    }, 46000);

    setTimeout(function () {
        smoke.addClass('smoke-show');
        smokeBg.show();
        playStoryVideo();
    }, 50000);

    setTimeout(function () {
        container.find('#story-sixth').fadeOut(500);
        container.find('#story-sixth').find('.JS-story-info').fadeOut(500);
        container.find('#story-first').addClass('last');
        container.find('#story-first').fadeIn(1000);
    }, 51000);

    setTimeout(function () {
        smoke.fadeOut(1000);
    }, 51500);

    setTimeout(function () {
        smoke.removeClass('smoke-show');
        smoke.removeAttr('style');
        smokeBg.hide();
    }, 53000);

    setTimeout(function () {
        container.find('#story-first').find('.JS-story-info').fadeIn(1000);
    }, 54000);
}

function playStoryVideo() {
    let container = $('.JS-story-animation-container');
    let smoke = container ? container.find('.JS-story-smoke') : null;

    if (smoke && smoke.find('video').get(0)) {
        smoke.find('video').get(0).play();
    }
}

(function ($) {
    'use strict';


    // ------------------------------------ Components ----------------------------------- \\

    Fullpage.guidepost();
    Gallery.postGallery();
    Parallax.init();
    // ScrollTo.init();

    // Animation
    Animation.donationProgressBar();
    Animation.progressStats();
    Animation.progressLine();
    //
    Accordion.init();
    Darujme.init();
    // Init

    ImageRatio.blockContentImages();
    JqueryValidator.define();
    Datepicker.init();
    FloatLabel.init('.moved-input-container');
    VterinaCounter.init();
    SignToDonate.init();

    // ------------------------------------ Events ----------------------------------- \\

    $(document).on('ready', function () {
        storyAnimation();
    });

    $(window).on('resize', function () {
        ImageRatio.blockContentImages();
    })

    $(window).on('scroll', function () {
        hideSignBtnAtScroll();
    });

    $(window).on('scroll', function () {
        let windowWidth = $(window).width();

        if (windowWidth >= 768) {
            return false;
        }

        $('.block-item').each(function () {
            let wasHovered = $(this).hasClass('m-once-hovered');

            if (($(window).scrollTop() + $(window).height() - 50 >= $(this).offset().top + $(this).height())
                && $(window).scrollTop() <= $(this).offset().top - 100) {

                if (wasHovered === false && $(this).hasClass('m-clicked') === false) {
                    $(this).addClass('m-once-hovered');
                    $(this).find(".block-item-inner").addClass('m-hovered');
                }
            } else if (($(window).scrollTop() >= $(this).offset().top + $(this).height())
                || ($(window).scrollTop() + $(this).height() < $(this).offset().top - $(this).height() + 150)) {
                $(this).removeClass('m-clicked');
                $(this).find(".block-item-inner").removeClass('m-clicked');
                $(this).removeClass('m-once-hovered');

                if (wasHovered === true) {
                    $(this).removeClass('m-once-hovered');
                    $(this).find(".block-item-inner").removeClass('m-hovered');
                }
            }
        });
    });

    $('.block-item').on('click', function () {
        let windowWidth = $(window).width();

        $('.block-item.m-clicked').find(".block-item-inner").removeClass('m-clicked');
        $('.block-item.m-clicked').removeClass('m-clicked');

        removeRotationFromBlockItem();

        $(this).addClass('m-clicked');
        $(this).find(".block-item-inner").addClass('m-clicked');
    });

    $(document).on('click', function (e) {
        let windowWidth = $(window).width();

        // TODO: sposobuje, ze nefunguje checkbox
        // if (windowWidth >= 768) {
        //     return false;
        // }

        if ($(e.target).parents('.block-item.m-clicked').length === 0) {
            removeRotationFromBlockItem();
        }
    });

    var touchStart = 0;
    var touchEnd = 0;

    $(document).on('touchstart', '.block-item', function (e) {
        var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
        touchStart = touch.pageX || touch.clientX;
    });

    $(document).on('touchend', '.block-item', function (e) {
        var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
        touchEnd = touch.pageX || touch.clientX;

        if (touchEnd > touchStart + 150) {
            touchStart = 0;
            touchEnd = 0;

            removeRotationFromBlockItem();
        } else if (touchEnd + 150 < touchStart) {
            touchStart = 0;
            touchEnd = 0;

            removeRotationFromBlockItem();

            $(this).addClass('m-clicked');
            $(this).find(".block-item-inner").addClass('m-clicked');
        }
    });

    function removeRotationFromBlockItem() {
        $('.block-item.m-clicked').find(".block-item-inner").removeClass('m-clicked');
        $('.block-item.m-clicked').removeClass('m-clicked');
    }


    // ------------------------------------ Old code ----------------------------------- \\

    $('[data-fancybox]').fancybox();

    var isTouchDevice = 'ontouchstart' in document.documentElement;
    if (isTouchDevice) {
        $('html').removeClass('no-touch');
    }

    if ($(".error404").length > 0) {
        $("html").addClass("html-page-404");
    }

    /**
     * Init int tel input
     */
    [].forEach.call(document.querySelectorAll('input[name=phone_number], input[name=phone]'), function (input) {

        var intlTelInput = window.intlTelInput(input, {
            hiddenInput: "phone",
            autoPlaceholder: "aggressive",
            initialCountry: "cz",
            preferredCountries: ["cz", "sk"]
        });

        // Trigger event 'intlInitialized'
        $(input).trigger('intlInitialized', {
            'data': intlTelInput
        });
    });

    window.lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });

    $(document).on("click", ".js-modal", function (e) {
        e.preventDefault();
        $(".js-overlay").addClass("is-show-modal");
        $(".js-modal-window").addClass("show-modal");
        var typeOfModal = $(this).attr("data-modal");
        $(".modal-" + typeOfModal).addClass("show-modal");
        $("html").addClass("modal-is-active");
    });

    $(document).on("click", ".js-overlay, .modal-window .js-close-modal", function (e) {
        e.preventDefault();
        $(".js-overlay").removeClass("is-show-modal");
        $(".modal-window").removeClass("show-modal");
        $("html").removeClass("modal-is-active");
    });

    $(".js-video-play-youtube").each(function () {
        var element = $(this);
        var elementVideo = element.find(".video");

        element.on("click", function (e) {
            e.preventDefault();

            $(this).find('iframe')[0].src += "&autoplay=1";
            $(this).find('.video-play-wrapper').remove();
            e.preventDefault();
        })
    });

    var js_slick_carousel = $('.js-slick-carousel').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    });

    js_slick_carousel.on('afterChange', function (slick, currentSlide) {
        $(currentSlide.$slides).each(function () {
            lazyLoadInstance.update();
        });
    });

    var js_slick_carousel_columns_one = $('.js-slick-carousel-columns-1').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000
    });

    js_slick_carousel_columns_one.on('afterChange', function (slick, currentSlide) {
        $(currentSlide.$slides).each(function () {
            lazyLoadInstance.update();
        });
    });

    var js_slick_carousel_columns_two = $('.js-slick-carousel-columns-2').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [{
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },]
    });

    js_slick_carousel_columns_two.on('afterChange', function (slick, currentSlide) {
        $(currentSlide.$slides).each(function () {
            lazyLoadInstance.update();
        });
    });

    var js_slick_carousel_columns_auto = $('.js-slick-carousel-auto').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        infinite: true,
        arrows: false,
        variableWidth: true
    });

    js_slick_carousel_columns_auto.on('afterChange', function (slick, currentSlide) {
        $(currentSlide.$slides).each(function () {
            lazyLoadInstance.update();
        });
    });

    var js_progress_stats_slick = $('.js-progress-stats-slick').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        arrows: false,
        variableWidth: true
    });

    js_slick_carousel_columns_auto.on('afterChange', function (slick, currentSlide) {
        $(currentSlide.$slides).each(function () {
            lazyLoadInstance.update();
        });
    });

    // TODO: move to Darujme class
    // Donate form

    $('input[name="frequency"]').on('change', function () {

        if ($(this).val() != 'once') {
            // ------------------------------ Monthly ----------------------------------- \\

            $('.form-info').hide();
            //
            $(".form-type-item").removeClass("active");
            $(this).closest("li").addClass("active");
            //
            var loop_count = 0;
            var amounts = $(this).closest('form').attr('data-amounts-monthly');

            if (amounts) {
                try {
                    amounts = JSON.parse(amounts);
                } catch (error) {
                    //
                    return;
                }
            }

            $('input[name="amount_radio"]').each(function () {
                var value = amounts[loop_count];
                // Vlastni
                if (loop_count >= 3) {
                    return;
                }
                //
                if (value) {
                    $(this).parent().show();
                    //
                    $(this).val(value);
                    $(this).parent().find('label').html(value + ' Kč');
                } else {
                    $(this).parent().hide();
                }
                //
                if ($(this).prop('checked') === true) {
                    $(this).trigger('change');
                }

                loop_count++;
            });

            $('input[name="monthsRecurring"]').hide();

        } else {
            // ------------------------------ Once ----------------------------------- \\

            $('.form-info').show();
            //
            $(".form-type-item").removeClass("active");
            $(this).closest("li").addClass("active");
            //
            var loop_count = 0;
            var amounts = $(this).closest('form').attr('data-amounts-once');

            if (amounts) {
                try {
                    amounts = JSON.parse(amounts);
                } catch (error) {
                    //
                    return;
                }
            }

            $('input[name="amount_radio"]').each(function () {
                var value = amounts[loop_count];

                // Vlastni
                if (loop_count >= 3) {
                    return;
                }
                //
                if (value) {
                    $(this).parent().show();
                    //
                    $(this).val(value);
                    $(this).parent().find('label').html(value + ' Kč');
                } else {
                    $(this).parent().hide();
                }
                //
                if ($(this).prop('checked') === true) {
                    $(this).trigger('change');
                }

                loop_count++;
            });


            $('input[name="monthsRecurring"]').show();
        }

    });

    $('input[name="amount_radio"]').on('change', function () {
        // On amount change

        if ($(this).val() === '0') {

            $('.form-amount-input').addClass("d-flex");
            $('input[name="amount_custom"]').trigger('change');

        } else {
            var value = parseInt($(this).val());

            if ($('input[name="naklady"]').is(':checked')) {

                value = value + (Math.ceil(value / 100 * greenpeace_donation_percent));

            } else {

                value = $(this).val();

            }

            // Update amount
            let amount = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            $('input[name="amount"]').val(value);
            $('.form-submit .btn-text').html(getSupportFormText(amount));
            $('.js-donate-form-amount').html(amount);
            $(this).closest('form').find('span.amount').html(value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Kč');
            $('.terms span').html(value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' '));

            $('.form-amount-input').removeClass("d-flex");
        }

    });

    $('input[name="amount_custom"]').on('change', function () {

        if ($(this).is(':visible') || $(this).val() > 0) {
            
            var value = parseInt($(this).val());

            if ($('input[name="naklady"]').is(':checked')) {

                value = value + (Math.ceil(value / 100 * greenpeace_donation_percent));

            } else {

                value = $(this).val();

            }

            if ($(this).val() <= 0) {
                // Update amount
                $('input[name="amount"]').val('0');
                $('.form-submit .btn-text').html(getSupportFormText(0));
                $('.js-donate-form-amount').html(0);
                $(this).closest('form').find('span.amount').html('0 Kč');
                $('.terms span').html('0');
            } else {
                // Update amount
                let amount = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                $('input[name="amount"]').val(value);
                $('.js-donate-form-amount').html(value);
                $('.form-submit .btn-text').html(getSupportFormText(amount));
                $(this).closest('form').find('span.amount').html(value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Kč');
                $('.terms span').html(value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
            }

        }

    });


    /**
     * Check if user has select monthly/recurring donate
     * @return {boolean}
     */
    function isMonthlyDonate() {
        if ($('#support-form input[name="frequency"]:checked').val() == 'monthly') {
            return true;
        } else {
            return false;
        }
    }

    /**
     * @param {Number} amount
     * @return {string}
     */
    function getSupportFormText(amount) {
        if (isMonthlyDonate()) {
            return 'Darovat měsíčně ' + amount + ' Kč';
        } else {
            return 'Darovat ' + amount + ' Kč';
        }
    }

    $('input[name="naklady"]').on('change', function () {

        $('input[name="amount_radio"]').each(function () {
            if ($(this).is(':checked')) {
                $(this).trigger('change');
            }
        });

        $('input[name="amount_custom"]').trigger('change');

    });


    /**
     * On select payment method
     */
    $('input[name="paymentMethod"]').on('change', function () {

        if ($(this).val() === 'proxypay_charge') {

            $('.form-selectbox').show();
            $('input[name="monthsRecurring"]').val('-2');

        } else {

            $('.form-selectbox').hide();
            $('input[name="monthsRecurring"]').val('-1');

        }

    });

    jQuery.validator.addMethod("phone_number", function (value, element) {
        // var pattern = /^(\+?[420]{3})?[\s]?([0-9]{3})[\s]?([0-9]{3})[\s]?([0-9]{3})$/;
        //
        // if (typeof telInput !== "undefined") {
        //     if (telInput.getSelectedCountryData().iso2 === "sk") {
        //         pattern = /^(\+?[421]{3})?[\s]?([0-9]{4})[\s]?([0-9]{3})[\s]?([0-9]{3})$/
        //     }
        // }
        //
        // return this.optional(element) || pattern.test(value);
        var iti = window.intlTelInputGlobals.getInstance(element)

        if (iti && iti.isValidNumber()) {
            return true;
        } else {
            return false;
        }
    }, "Zadejte platné tel. číslo");

    // $('.petition-form input[name=phone_number]').on('focus', function() {
    //     var value = $(this).val();
    //
    //     if (typeof telInput !== "undefined") {
    //         if (telInput.getSelectedCountryData().iso2 === "sk") {
    //             if (!value.startsWith('+421')) {
    //                 $(this).val('+421' + value);
    //             }
    //         } else {
    //             if (!value.startsWith('+420')) {
    //                 $(this).val('+420' + value);
    //             }
    //         }
    //     } else {
    //         if (!value.startsWith('+420')) {
    //             $(this).val('+420' + value);
    //         }
    //     }
    // }).on('focusout', function() {
    //     if ($(this).val().length <= 4) {
    //         $(this).val('');
    //     }
    // });

    var isStandardPetitionSubmitting = false;

    $('.petition-form').validate({
        errorClass: 'invalid',
        rules: {
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            email: {
                required: true,
                email: true
            },
            date_of_birth: {
                required: true,
                birthdate: true,
                birthdate_age_restriction: true
            },
            phone_number: {
                required: true,
                phone_number: true
            },
            zip_code: {
                required: false,
                zip_code: true
            }
        },
        messages: {
            first_name: {
                required: "Povinné pole"
            },
            last_name: {
                required: "Povinné pole"
            },
            email: {
                required: "Povinné pole",
                email: "Neplatný formát"
            },
            date_of_birth: {
                required: "Povinné pole",
                birthdate: "Datum není valídni",
                birthdate_age_restriction: "Musí ti být nejméně 13 let"
            },
            phone_number: {
                required: "Povinné pole",
                phone_number: "Neplatný formát"
            }
        },
        submitHandler: async function (form, event) {
            event.preventDefault(); // Vždy nejprve zastavíme odeslání

            // Zkontrolujeme, jestli formulář NENÍ Sign to Donate
            // Pokud má atribut, tak to NENÍ standardní petice a tento handler má skončit.
            if ($(form).attr('data-ajax-form') === 'sign_to_donate_petition_form') {
                // Tento formulář má na starosti SignToDonate.js, takže tady nic neděláme.
                return;
            }

            // --- Zde začíná logika POUZE pro standardní petice ---
            if (isStandardPetitionSubmitting) {
                return; // Zámek proti dvojitému kliknutí
            }
            isStandardPetitionSubmitting = true;

            var $form = $(form);

            // Krok 1: Validace Cloudflare
            if (!CloudflareTurnstille.validate($form)) {
                CloudflareTurnstille.handleInvalidForm($form);
                isStandardPetitionSubmitting = false; // Odemkneme
                return;
            }

            // Krok 2: Zpracování dataLayer
            const email = $form.find('input[name="email"]').val();
            let hashedEmail = null;

            if (email) {
                hashedEmail = await GA.sha256(email);
            }
            
            console.log("-> GTM Event z main.js (standardní petice)");

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'petitionSignup',
                'gp_user_id': hashedEmail
            });

            // Krok 3: Odeslání formuláře
            form.submit();
        }
    });

    $('.js-task-form').on('submit', async function (event) {
        event.preventDefault(); 
        const $form = $(this);

        if ($form.valid()) {
            const email = $form.find('input[name="email"]').val() || '';
            let hashedEmail = null;

            if (email) {
                hashedEmail = await GA.sha256(email);
            }

            window.dataLayer = window.dataLayer || [];

            if (!window.dataLayerPushed) {
                dataLayer.push({
                    'event': 'engagementActivity',
                    'eventCategory': 'engagement',
                    'gp_user_id': hashedEmail
                });
                window.dataLayerPushed = true;
                
//                console.log('EVENT: engagementActivity (Task Form)', JSON.stringify(dataLayer.at(-1)));
            }

            // Manuálně odešleme formulář až poté, co je vše hotovo
            $form.get(0).submit(); 
        }
    });

    // Socials form
    $('.socials-form').on('submit', function (event) {
        // Pokud formulář neprojde validací, nic neděláme.
        // Knihovna jQuery.validate se postará o zobrazení chyb.
        if (!$(this).valid()) {
            return;
        }

        // Pokud je formulář validní, provedeme logiku z původního "else if" bloku.
        // Tím zabráníme dvojitému odeslání a zobrazíme "loading" stav.
        var $submit = $(this).find('button[type=submit], input[type=submit]');
        $submit
            .addClass('js-loading')
            .attr('disabled', 'disabled');
    });


    $('.socials-form').validate({
        errorClass: 'invalid',
        rules: {
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            email: {
                required: true,
                email: true
            },
            recipient_email: {
                required: true
            },
            subject: {
                required: true
            },
            message: {
                required: true
            },
            zip_code: {
                required: false,
                zip_code: true
            }
        },
        messages: {
            first_name: {
                required: "Povinné pole"
            },
            last_name: {
                required: "Povinné pole"
            },
            email: {
                required: "Povinné pole"
            },
            recipient_email: {
                required: "Povinné pole",
                email: "Neplatný formát"
            },
            subject: {
                required: "Povinné pole"
            },
            message: {
                required: "Povinné pole"
            },
        },
        submitHandler: function (form) {
            var $form = $(form);

            // Validate CF turnstille
            if(!CloudflareTurnstille.validate($form)) {
                CloudflareTurnstille.handleInvalidForm($form);
                //
                return;
            }

            // Submit form
            form.submit();
        },
    });

    $(document).on('input', '.js-char-counter', function (e) {
        var counterSelector = $(this).attr('data-counter-selector');
        var $counter = $(counterSelector);
        var count = $(this).val().length;
        //
        $counter.text(count);
    });

    // Bully email form
    $(document).on('submit', '#bully-email-form', async function (event) {
        event.preventDefault();
        const $form = $(this);

        if ($form.valid()) {
            const email = $form.find('input[name="email"]').val() || '';
            let hashedEmail = null;

            if (email) {
                hashedEmail = await GA.sha256(email);
            }

            window.dataLayer = window.dataLayer || [];

            if (!window.dataLayerPushed) {
                dataLayer.push({
                    'event': 'engagementActivity',
                    'eventCategory': 'engagement',
                    'gp_user_id': hashedEmail
                });
                window.dataLayerPushed = true;
                
//                console.log('EVENT: engagementActivity (Bully Form)', JSON.stringify(dataLayer.at(-1)));
            }

            // Tento formulář je specifický a je odesílán jinou funkcí ('bully_general_form'),
            // takže zde nevoláme submit() přímo. Necháme původní logiku formuláře pracovat.
            // Původní kód vracel 'true', ale protože je obsluhován jinde,
            // je bezpečnější nechat doběhnout zbytek skriptů.
            // Pokud by odeslání selhalo, je třeba zavolat $form.get(0).submit();
        }
    });

    // Collection creation form

    $('.js-collection-creation-form').on('submit', async function (event) {
        var form = $(this);

        if (!form.valid()) {
            form.find('.form-submit').removeClass('js-loading');
        }

        // Send google analytics data layer
        if (form.valid()) {
            event.preventDefault();
            var $form = $(form);

            // Validate CF turnstile
            if(!CloudflareTurnstille.validate($form)) {
                CloudflareTurnstille.handleInvalidForm($form);
                return;
            }

            const email = $form.find('input[name="email"]').val();
            let hashedEmail = null;

            if (email) {
                hashedEmail = await GA.sha256(email);
            }

            if (!window.dataLayerPushed) {
                // Send
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'event': 'engagementActivity',
                    'eventCategory': 'engagement',
                    'gp_user_id': hashedEmail
                });
                window.dataLayerPushed = true;
                
//                console.log('EVENT: engagementActivity (Collection Creation)', JSON.stringify(dataLayer.at(-1)));
            }

            // Submit
            form[0].submit();
        }

        // Show personal data modal
        if (form.valid()) {
            event.preventDefault();
            form.find('.form-submit').removeClass('js-loading');
        }
    });

    // Collection petition form

    $('.js-collection-petition-form').on('submit', async function (event) {
        var form = $(this);

        if (!form.valid()) {
            form.find('.form-submit').removeClass('js-loading');
        }

        // Send google analytics data layer
        if (form.valid()) {
            event.preventDefault();
            var $form = $(form);

            // Validate CF turnstille
            if(!CloudflareTurnstille.validate($form)) {
                CloudflareTurnstille.handleInvalidForm($form);
                return;
            }
            
            const email = $form.find('input[name="email"]').val();
            let hashedEmail = null;

            if (email) {
                hashedEmail = await GA.sha256(email);
            }

             if (!window.dataLayerPushed) {
                // Send
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'event': 'petitionSignup',
                    'gp_user_id': hashedEmail
                });
                window.dataLayerPushed = true;
                
//                console.log('EVENT: petitionSignup (Collection Petition)', JSON.stringify(dataLayer.at(-1)));
            }

            // Submit
            form[0].submit();
        }

        // Show personal data modal
        if (form.valid()) {
            event.preventDefault();
            form.find('.form-submit').removeClass('js-loading');
        }
    });

    // Support form
    var support_form_count = 0;

    $('#support-form input[name="frequency"]').on('change', function (event) {
        if ($(this).val() == 'once' && support_form_count === 0) {
            // Show popup?
            event.preventDefault();
            if ($('#support-form').attr('data-show-popup')) {
                event.preventDefault();

                $.fancybox.open({
                    src: '#tip-modal'
                });
            }

            support_form_count = 1;
        }
    });

    // Support form
    $('.support-form').validate({
        errorClass: 'invalid',
        rules: {
            amount: {
                required: true,
                number: true
            },
            amount_custom: {
                required: true,
                number: true
            },
            firstName: 'required',
            lastName: 'required',
            email: {
                required: true,
                email: true
            },
            phone_number: {
                phone_number: true
            },
            card_type: 'required'
        },
        messages: {
            amount: {
                required: "Povinné pole",
                number: "Neplatný formát"
            },
            amount_custom: {
                required: "Povinné pole",
                number: "Neplatný formát"
            },
            firstName: {
                required: "Povinné pole"
            },
            lastName: {
                required: "Povinné pole"
            },
            email: {
                required: "Povinné pole",
                email: "Neplatný formát"
            },
            phone_number: {
                required: "Povinné pole",
                phone_number: "Neplatný formát"
            },
            card_type: {
                required: "Povinné pole"
            }
        },
        submitHandler: function (form) {
            var $form = $(form);

            // Validate CF turnstille
            if(!CloudflareTurnstille.validate($form)) {
                CloudflareTurnstille.handleInvalidForm($form);
                //
                return;
            }

            // Submit form
            form.submit();
        },
    });

    // Task form
    $('.js-task-form').validate({
        errorClass: 'invalid',
        rules: {
            zip_code: {
                required: false,
                zip_code: true
            }
        },
        messages: {
            //
        },
        submitHandler: function (form) {
            var $form = $(form);

            // Validate CF turnstille
            if(!CloudflareTurnstille.validate($form)) {
                CloudflareTurnstille.handleInvalidForm($form);
                //
                return;
            }

            // Submit form
            form.submit();
        },
    });

    // Collection creation form
    $('.js-collection-creation-form').validate({
        errorClass: 'invalid',
        rules: {
            phone_number: {
                required: true,
                phone_number: true,
            },
            first_name: {
                required: true,
            },
            last_name: {
                required: true,
            },
            email: {
                required: true,
                email: true
            },
            zip_code: {
                required: false,
                zip_code: true
            }
        },
        messages: {
            first_name: {
                required: "Povinné pole"
            },
            lastName: {
                required: "Povinné pole"
            },
            email: {
                required: "Povinné pole",
                email: "Neplatný formát"
            },
            phone_number: {
                required: "Povinné pole",
                phone_number: "Neplatný formát"
            },
        },
        submitHandler: function (form) {
            var $form = $(form);

            // Validate CF turnstille
            if(!CloudflareTurnstille.validate($form)) {
                CloudflareTurnstille.handleInvalidForm($form);
                //
                return;
            }

            // Submit form
            form.submit();
        },
    });

    // Quiz form
    $('.js-quiz-form').validate({
        errorClass: 'invalid',
        rules: {
            //
        },
        messages: {
            //
        },
        submitHandler: function (form) { 

            var $form = $(form);

            // Validate CF turnstille
            if(!CloudflareTurnstille.validate($form)) {
                CloudflareTurnstille.handleInvalidForm($form);
                //
                return;
            }

            var formData = $('#quiz-form').serialize(); // Serializace dat formuláře
            
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: formData, // Odeslání serializovaných dat
                // success: function(response) {
                //     if (response.success) {
                //         // Úspěšná odpověď, zpracování výsledků
                //         // console.log('Success:', response.data.snippets);
                //         $('#quiz').html(response.data.snippets['#quiz']); // Aktualizace obsahu
                //         $('html, body').animate({ scrollTop: 0 }, 1000);
                        

                //     } else {
                //         // Zpracování chyby
                //         console.error('Error:', response);
                //     }
                // },
                success: function (response) {
                    const data = response.data;
                    const snippets = data.snippets;
    
                    // Redraw snippets
                    for (const snippet in snippets) {
                        const content = snippets[snippet];
                        // Redraw snippet
                        $(snippet).html(content);
                    }

                    // $('html, body').animate({ scrollTop: 0 }, 1000);


                    // Petition signup
                    // var email = document.querySelector('[name=email]').value ?? '';
                    // window.dataLayer = window.dataLayer || [];
                    // dataLayer.push({
                    //     'event' : 'engagementActivity',
                    //     'eventCategory' : 'engagement',
                    //     'userEmail': email
                    // });

                    // Show modal
                    $(function() {
                        $.fancybox.open({
                            src: '#quiz-modal'
                        });
                    });

                    // Scroll to first answer
                    $('#quiz-modal [data-fancybox-close]').on('click', function() {
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(".js-quiz-question").offset().top - 50
                        }, 1000);
                    });

                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.error('AJAX Error:', textStatus, errorThrown);
                }
            });



        
              


        },
    });

    $('.js-collection-petition-form').validate({
        errorClass: 'invalid',
        rules: {
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            email: {
                required: true,
                email: true
            },
            phone_number: {
                required: true,
                phone_number: true,
            },
            date_of_birth: {
                required: true,
                birthdate: true,
            },
            zip_code: {
                required: false,
                zip_code: true
            }
        },
        messages: {
            first_name: {
                required: "Povinné pole"
            },
            last_name: {
                required: "Povinné pole"
            },
            email: {
                required: "Povinné pole",
                email: "Neplatný formát"
            },
            date_of_birth: {
                required: "Povinné pole",
                birthdate: "Datum není valídni",
                birthdate_age_restriction: "Musí ti být nejméně 13 let"
            },
            phone_number: {
                required: "Povinné pole",
                phone_number: "Neplatný formát"
            }
        },
        submitHandler: function (form) {
            var $form = $(form);

            // Validate CF turnstille
            if(!CloudflareTurnstille.validate($form)) {
                CloudflareTurnstille.handleInvalidForm($form);
                
                return;
            }

            // Submit form
            form.submit();
        },
    })

    // Support form
    $('.support-form').on('submit', async function (event) {
        const $form = $(this);

        if (!$form.valid()) {
            return;
        }

        event.preventDefault();

        const action = $form.find('.js-donate-frequency.active input[name=frequency]').val();
        const value = $form.find('input[name=amount]').val();
        const email = $form.find('input[name=email]').val();
        let hashedEmail = null;

        if (email) {
            hashedEmail = await GA.sha256(email);
        }

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'donateForm',
            'eventCategory': 'Donation',
            'eventAction': (action === 'monthly' ? 'regular' : 'single'),
            'eventLabel': 'CZK',
            'eventValue': value,
            'gp_user_id': hashedEmail
        });
        
//        console.log('EVENT: donateForm (Donate Form)', JSON.stringify(dataLayer.at(-1))); 
        
        $form.get(0).submit();
    });

    var seconds = 0;
    var minutes = 0;
    var hours = 0;

    setInterval(function () {
        seconds = seconds + 1;

        minutes = minutes + Math.floor(seconds / 60);
        hours = hours + Math.floor(seconds / 3600);

        if (seconds == 60) {
            seconds = 0;
        }

        $('.timer__countdown').html((minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds));

        $('.stats__item').each(function () {
            var number = parseInt($(this).find('.stats__number').html().replace(/\s/g, ''));
            number = number + parseInt($(this).find('.stats__number').data('every-second'));

            $(this).find('.stats__number').html(number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
        });

    }, 1000);

    var js_slick_carousel_timeline = $('.js-slick-timeline').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: false,
        prevArrow: '<div class="timeline-pagination prev"><button type="button" class="slick-arrow slick-prev">Previous</button></div>',
        nextArrow: '<div class="timeline-pagination next"><button type="button" class="slick-arrow slick-next">Next</button></div>',
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    variableWidth: false,
                    adaptiveHeight: true
                }
            }
        ]
    });

    js_slick_carousel_timeline.on('afterChange', function (slick, currentSlide) {
        $(currentSlide.$slides).each(function () {
            lazyLoadInstance.update();
        });
    });

    if (window.matchMedia("(max-width: 767.98px)").matches) {
        $("html").addClass("bpXs");

        $(document).on("click touchstart", ".js-overlay, .js-close", function (e) {
            $('.navbar-responsive-menu').removeClass("menu-is-active");
            $("html").removeClass("responsive-menu-is-show");
            e.preventDefault();

            setTimeout(function () {
                $(".js-navbar-toggle").removeClass("no-pointer-event");
            }, 500);
        });

        if ($(".js-timeline-xs .timeline-post-slide").length > 0) {
            $(".js-timeline-xs .timeline-post-slide").each(function () {
                var element = $(this);

                if ($(".js-timeline-xs .timeline-post-slide").length > 2) {
                    element.closest(".timeline-wrap").addClass("toggle-height");
                }
            })
        }

        $(".js-next-xs").on("click", function (e) {
            e.preventDefault();


            if ($(".js-show-timeline-wrap").hasClass("toggle-height-open")) {
                $('html, body').animate({
                    scrollTop: $(".js-timeline-xs").offset().top - 120
                }, 1000);

                setTimeout(function () {
                    $(".js-show-timeline-wrap").removeClass("toggle-height-open");
                }, 1500)
            }
            $(".js-show-timeline-wrap").addClass("toggle-height-open");
        });

        $(".js-navbar-toggle").click(function (e) {
            e.preventDefault();
            if ($(".navbar-responsive-menu").hasClass("menu-is-active")) {
                $("html").removeClass("responsive-menu-is-show");
                $('.navbar-responsive-menu').removeClass("menu-is-active");
            } else {
                $("html").addClass("responsive-menu-is-show");
                $('.navbar-responsive-menu').addClass("menu-is-active");
                $(this).addClass("no-pointer-event");
            }
        });
    };


    // $(window).on('load', function (event) {
    //     var target = $(window.location.hash);
    //     const isFullpage = document.querySelector('html').classList.contains('fp-enabled');
    //     const isGuidePost = document.body.classList.contains('page-template-guidepost-page');
    //     if (target.length && !isFullpage) {
    //         // Only prevent default if animation is actually gonna happen
    //         event.preventDefault();
    //         let offset = target.offset().top - (target.offset().top > 74 ? 74 : 0);
    //         if (isGuidePost) {
    //             const section = $(target).closest('.stage-box');
    //             offset = section.offset().top;
    //         }
    //         $('html, body').animate({
    //             scrollTop: offset
    //         }, 1000, function () {
    //         });
    //     }
    // });

    // $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function (event) {
    //     if ($(this).attr('data-fancybox') !== typeof undefined && $(this).attr('onclick') === typeof undefined) {
    //         if (
    //             location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
    //             location.hostname == this.hostname
    //         ) {
    //             var target = $(this.hash);
    //             target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    //             if (target.length) {
    //                 // Only prevent default if animation is actually gonna happen
    //                 event.preventDefault();

    //                 $('html, body').animate({
    //                     scrollTop: target.offset().top - (target.offset().top > 74 ? 74 : 0)
    //                 }, 1000, function () {
    //                 });
    //             }
    //         }
    //     }
    // });

    $('.tabs-nav ul li a').on('click', function (event) {
        event.preventDefault();

        var target = $(this).attr('href');
        $(this).closest('ul').find('.active').removeClass('active');
        $(this).addClass('active');

        $('.tabs-item--active').removeClass('tabs-item--active');
        $(target).addClass('tabs-item--active');

        return false;
    });

    $(document).on("scroll", function () {
        var pos = $(window).scrollTop();
        var navbarHeight = $(".js-header-navbar").innerHeight();
        var windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        $(".js-header-navbar").toggleClass('take-menu-start', pos > navbarHeight && windowWidth > 1).toggleClass('take-menu-start-between', pos > (navbarHeight * 1.5) && windowWidth > 1).toggleClass('take-menu', pos > (navbarHeight * 1.8) && windowWidth > 1);

        if ($(window).scrollTop() >= $('.website-footer').offset().top) {
            $('.js-header-navbar').hide();
        } else {
            $('.js-header-navbar').show();
        }
    }).load();

    $(window).on('load', function () {
        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            $("html").addClass("iOS");
        }
    });

    $('div.editor-twitter').on('keyup keydown paste', function (event) { //Prevent on paste as well

        //Just for info, you can remove this line
        // $('span').text('Total chars:' + $(this).text().length);

        //You can add delete key event code as well over here for windows users.
        if ($(this).text().length === 280 && event.keyCode != 8) {
            event.preventDefault();
        }

        $(this).next('span').html('Počet znaků: <strong>' + $(this).text().length + '</strong> z <strong>280</strong>');
    });

    // Collection creation slider
    const rangeSlider = document.getElementById('collection-goal-slider');

    if (rangeSlider) {
        const slider = noUiSlider.create(rangeSlider, {
            start: [parseInt(rangeSlider.getAttribute('data-init'))],
            range: {
                'min': [0],
                'max': [parseInt(rangeSlider.getAttribute('data-limit'))]
            },
            connect: [true, false],
        });

        // Update goalOutput input value on slider change
        slider.on('update', (value) => {
            value = Math.round(value);

            document.querySelector('#goalOutput').value = value;
        });

    }

    /**
     * @param {Number} number
     * @return string
     */
    function getNumberDigits(number) {
        return number.toString().length;
    }

    // Prevent from inserting number greater than max allowed number
    document.querySelectorAll('input[type="number"]').forEach((element) => {
        element.addEventListener('input', (e) => {
            const max = parseInt(element.getAttribute('max'));
            const value = parseInt(element.value);
            const digits = getNumberDigits(max);

            if (value > max) {
                const maxString = value.toString().substring(0, digits);

                element.value = parseInt(maxString);
            }
        });
    });

    // Quiz show next question if user answer previous one
    $('.js-quiz-option-input').on('click', function (e) {
        var $question = $(this).closest('.js-quiz-question');
        var $nextQuestion = $question.next().next();

        if ($nextQuestion.hasClass('js-quiz-question') && !$nextQuestion.hasClass('is-visible')) {
            $nextQuestion.addClass('is-visible');
            // Scroll to nextQuestion
            $([document.documentElement, document.body]).animate({
                scrollTop: $nextQuestion.offset().top
            }, 1000);
        }

        // Check if quiz has all input selected
        toggle_quiz_submit_button();
    });

    // Show quiz submit button if all questions are answered
    function toggle_quiz_submit_button() {
        var inputNames = {};
        var valid = true;
        var $submit = $('.js-quiz-submit');

        // Get all radio input names
        $('.js-quiz-option-input').each(function (index, element) {
            var $element = $(element);
            inputNames[$element.attr('name')] = $element.attr('name');
        })

        // Find if all input names are selected
        for (var property in inputNames) {

            if (!$('input[name="' + property + '"]').is(':checked')) {
                valid = false;
                break;
            }
        }

        if (valid) {
            $submit.show();
        } else {
            $submit.hide();
        }
    }

    // Check if quiz has all input selected
    toggle_quiz_submit_button();

    /**
     * Init UTM data from query URL
     */
    function init_forms_utm_data() {
        const params = (new URL(document.location)).searchParams;
        //
        const utm_source = params.get('utm_source');
        const utm_medium = params.get('utm_medium');
        const utm_campaign = params.get('utm_campaign');
        const utm_content = params.get('utm_content');
        const utm_term = params.get('utm_term');
        //
        if ($('input[name="utm_source"]').length > 0) {
            $('input[name="utm_source"]').val(utm_source);
        }
        if ($('input[name="utm_medium"]').length > 0) {
            $('input[name="utm_medium"]').val(utm_medium);
        }
        if ($('input[name="utm_campaign"]').length > 0) {
            $('input[name="utm_campaign"]').val(utm_campaign);
        }
        if ($('input[name="utm_content"]').length > 0) {
            $('input[name="utm_content"]').val(utm_content);
        }
        if ($('input[name="utm_term"]').length > 0) {
            $('input[name="utm_term"]').val(utm_term);
        }
    }

    init_forms_utm_data();

    // on load
    CloudflareTurnstille.onLoad();

})(jQuery);


/**
 * GW-18: Logika pro dynamické počítadlo [gp_counter]
 */
document.addEventListener('DOMContentLoaded', function() {
    
    // Najdeme všechny countery na stránce
    const counters = document.querySelectorAll('.gp-counter-number');

    if (counters.length === 0) {
        return; // Žádné countery nenalezeny, končíme.
    }

    // Funkce pro formátování čísla (přidá mezery jako oddělovače tisíců)
    function formatNumber(number) {
        // Použijeme pevnou mezeru (NBSP), aby se číslo nezalamovalo
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
    }

    // Projdeme všechny nalezené countery a spustíme je
    counters.forEach(counter => {
        try {
            // 1. Načteme hodnoty z data atributů
            let currentValue = parseInt(counter.dataset.startValue, 10);
            const incrementRate = parseInt(counter.dataset.incrementRate, 10);

            // Zkontrolujeme, jestli jsou hodnoty platná čísla
            if (isNaN(currentValue) || isNaN(incrementRate)) {
                console.error('GP Counter: Neplatné data atributy pro counter.', counter);
                return; // Přeskočíme tento counter
            }
            
            // 2. Nastavíme interval (1000ms = 1 sekunda)
            setInterval(function() {
                // 3. Navýšíme hodnotu
                currentValue += incrementRate;
                
                // 4. Aktualizujeme HTML elementu
                counter.textContent = formatNumber(currentValue);
            }, 1000);

        } catch (e) {
            console.error('GP Counter: Chyba při inicializaci counteru.', e, counter);
        }
    });
});